/**
 * @abstract
 */
export default class Scene {
  constructor(renderer, syncDevice) {
    this.paused = false;
    this.syncDevice = syncDevice;
  }

  /**
   * Set paused
   * @param paused
   */
  setPaused(paused) {
    this.paused = paused;
  }

  /**
   * Interpolate values
   * @param a
   * @param b
   * @param step
   * @param length
   * @returns float
   */
  interpolate(a, b, step, length) {
    if (this.paused) {
      return b;
    }
    return a + ((b - a) * (step / length));
  };
}
